import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import CompactInlineCountryCycler from "./MadeFrom";

const HomeFooter = () => {
  const location = useLocation();
  const [isViewStoryRoute, setisViewStoryRoute] = useState(true);
  // Check if the current route matches the /view-story/:storyId pattern
  useEffect(() => {
    setisViewStoryRoute(location.pathname.startsWith("/view-story/"));
  }, []);

  function getYear() {
    return new Date().getFullYear();
  }
  return (
    <>
      {!isViewStoryRoute && (
        <div>
          <footer className="bg-[#002238] dark:bg-gray-900">
            <div className="mx-auto w-full max-w-screen-xl p-4  lg:py-8 text-sm text-white">
              <div className="sm:flex sm:items-center sm:justify-between">
                <div className="sm:text-center dark:text-gray-400 text-center">
                  © {getYear()}{" "}
                  <span>
                    <NavLink to="/">Comicfy</NavLink>{" "}
                  </span>
                  | All Rights Reserved.
                </div>
                <CompactInlineCountryCycler />
                <div className="flex mt-4 sm:justify-center justify-center sm:mt-0">
                  <Link to="/terms-of-service">
                    <span>Terms And Conditions </span>
                  </Link>{" "}
                  &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                  <Link to="/privacy-policy">
                    <span> Privacy Policy</span>
                  </Link>
                </div>
              </div>
            </div>
          </footer>
        </div>
      )}
    </>
  );
};

export default HomeFooter;
